import { backofficeRegionRepository } from '@search/backoffice-const/src/constants';

export function offerRegionToMortgage(regionId?: number | null): number {
    const boRegion = regionId ? backofficeRegionRepository.byGeoId(regionId) : undefined;

    return boRegion ? Number(boRegion.value) : 3;
}
